<template>
  <button
    v-if="visible"
    type="button"
    class="btn btn-sm btn-outline-primary mx-1"
    :title="$t('notaComercial.pdf.openTitle')"
    @click="openPdf"
  >
    <i class="fas fa-file-pdf me-1" aria-hidden="true"></i>
    {{ $t("notaComercial.pdf.openButton") }}
  </button>
</template>

<script>
export default {
  name: "NotaComercialPdfButton",
  props: {
    notaId: {
      type: String,
      required: true,
    },
    notaComercialModuleActive: {
      type: Boolean,
      default: false,
    },
    /**
     * `flow_direction` de la nota. Solo las `Giving` las emitimos nosotros y llevan PDF;
     * las `Receiving` son documento del contacto. Sin dato no se muestra: más vale
     * esconder el botón que ofrecer el PDF de una nota que no emitimos.
     */
    flowDirection: {
      type: String,
      default: "",
    },
  },
  computed: {
    /** Solo emitimos PDF de las notas que damos nosotros. */
    weIssueThisNote() {
      return String(this.flowDirection || "").trim().toLowerCase() === "giving";
    },
    visible() {
      return this.notaComercialModuleActive && !!this.notaId && this.weIssueThisNote;
    },
  },
  methods: {
    openPdf() {
      if (!this.notaId) return;
      const route = this.$router.resolve({
        name: "DocumentTemplate",
        params: { type: "nota-comercial", id: String(this.notaId) },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>
